import { render } from "./ButtonPanel.vue?vue&type=template&id=5af01ad4&scoped=true"
import script from "./ButtonPanel.vue?vue&type=script&lang=js"
export * from "./ButtonPanel.vue?vue&type=script&lang=js"

import "./ButtonPanel.vue?vue&type=style&index=0&id=5af01ad4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5af01ad4"]])

export default __exports__